import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  max-width: 1529px !important;
  min-width: 633px !important;
`

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  gap: ${props => props.theme.spacing.sp32};

  & > div:first-child {
    width: 100%;
    height: fit-content;
  }
  & > div:last-child {
    min-width: 360px;
  }

  @media screen and (max-width: 1163px) {
    flex-direction: column;
    & > div:first-child {
      width: auto;
    }
    & > div:last-child {
      max-width: 100%;
    }
  }
`

export const ProductsCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const LineItemRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`

export const LineItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  flex: 1;
`

export const LineItemChipsRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const LineItemBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const SummaryCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const SummaryLines = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const SummaryActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`
